class CustomMegaMenu {
  constructor() {
    this.init();
  }

  init() {
    this.setupVerticalTabs();
    this.setupHorizontalTabs();
    this.setupHorizontalScroll();
    this.setupMobileHandling();
  }

  setupVerticalTabs() {
    const verticalMenus = document.querySelectorAll(".mega-menu-vertical");

    verticalMenus.forEach((menu) => {
      const tabs = menu.querySelectorAll(".mega-menu-vertical__tab");
      const panels = menu.querySelectorAll(".mega-menu-vertical__panel");

      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          // Remove active class from all tabs and panels
          tabs.forEach((t) => t.classList.remove("active"));
          panels.forEach((p) => p.classList.remove("active"));

          // Add active class to clicked tab and corresponding panel
          tab.classList.add("active");
          if (panels[index]) {
            panels[index].classList.add("active");
          }
        });
      });
    });
  }

  setupHorizontalTabs() {
    const horizontalMenus = document.querySelectorAll(".mega-menu-horizontal");

    horizontalMenus.forEach((menu) => {
      const tabs = menu.querySelectorAll(".mega-menu-horizontal__tab");
      const panels = menu.querySelectorAll(".mega-menu-horizontal__panel");

      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          // Remove active class from all tabs and panels
          tabs.forEach((t) => t.classList.remove("active"));
          panels.forEach((p) => p.classList.remove("active"));

          // Add active class to clicked tab and corresponding panel
          tab.classList.add("active");
          if (panels[index]) {
            panels[index].classList.add("active");
          }
        });
      });
    });
  }

  setupHorizontalScroll() {
    const scrollWrappers = document.querySelectorAll(
      ".mega-menu-horizontal__tabs-wrapper"
    );

    scrollWrappers.forEach((wrapper) => {
      const scrollContainer = wrapper.querySelector(
        ".mega-menu-horizontal__tabs-scroll"
      );
      const leftBtn = wrapper.querySelector(
        ".mega-menu-horizontal__scroll-btn--left"
      );
      const rightBtn = wrapper.querySelector(
        ".mega-menu-horizontal__scroll-btn--right"
      );

      if (!scrollContainer || !leftBtn || !rightBtn) return;

      const updateScrollButtons = () => {
        const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;

        leftBtn.style.display = scrollLeft > 0 ? "flex" : "none";
        rightBtn.style.display =
          scrollLeft < scrollWidth - clientWidth - 1 ? "flex" : "none";
      };

      const scrollAmount = 200;

      leftBtn.addEventListener("click", () => {
        scrollContainer.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      });

      rightBtn.addEventListener("click", () => {
        scrollContainer.scrollBy({ left: scrollAmount, behavior: "smooth" });
      });

      scrollContainer.addEventListener("scroll", updateScrollButtons);

      // Initial check
      updateScrollButtons();

      // Check on resize
      window.addEventListener("resize", updateScrollButtons);
    });
  }

  setupMobileHandling() {
    // On mobile, mega menu is hidden and regular drawer menu is used
    // This method ensures proper cleanup if needed
    const checkMobile = () => {
      const megaMenu = document.querySelector(".custom-mega-menu");
      if (megaMenu) {
        if (window.innerWidth <= 990) {
          megaMenu.style.display = "none";
        } else {
          megaMenu.style.display = "block";
        }
      }
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
  }
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new CustomMegaMenu();
});

// Reinitialize on theme editor changes
document.addEventListener("shopify:section:load", () => {
  new CustomMegaMenu();
});
